<template>
  <div id="contract-print">
    <print ref="print">
      <page>
        <div class="nation">{{ $t('NATION') }}</div>
        <div class="motto">{{ $t('MOTTO') }}</div>
        <br/>
        <div class="hr"/>
        <div class="header">
          <div class="logo-holder">
            <logo-inversed-circle class="icon"/>
            <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
          </div>
          <div class="title-info">
            <span class="bill">{{ $t('MORTGAGE_CONTRACT') }}</span>
            <br/><br/>
            <strong class="info">{{ $t('CONTRACT_ID') }} ({{ $t('CNTRCT') }}): {{ branch.name }}-{{ contract.mifosId }}</strong><br/>
            <strong class="info">{{ $t('CLIENT_ID') }} (KH): HCMKH-{{ contract.client.mifosId }}</strong><br/>
          </div>
        </div>
        <br/>
        <br/>
        <br/>
        <span>{{ $t('DATE') }} {{ moment(contract.maturesDate, DATE_FORMAT).format('DD-M-YYYY') }}, {{ $t('BEGIN_PARAM') }}:</span>
        <br/>
        <br/>
        <b-row>
          <b-col cols="6">
            <span><strong>{{ $t('CLIENT_SIDE') }}:</strong></span>
            <table>
              <tr>
                <td class="label">{{ $t('FULL_NAME') }}:</td>
                <td><span>{{ contract.client.name }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('PHONE_NUMBER') }}:</td>
                <td><span>{{ contract.client.primaryPhone }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('BORN_DAY') }}:</td>
                <td><span>{{ moment(contract.client.dateOfBirth, DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('NATIONAL_ID') }}:</td>
                <td><span>{{ contract.client.nationalId }}</span></td>
              </tr>
              <template v-if="isPurchased && contract.asset.meta.clientName2">
                <tr>
                  <td class="label">{{ $t('FULL_NAME') }} {{ $t('WIFE/HUSBAND') }}:</td>
                  <td><span>{{ contract.asset.meta.clientName2 }}</span></td>
                </tr>
                <tr>
                  <td class="label">{{ $t('NATIONAL_ID') }}:</td>
                  <td><span>{{ contract.asset.meta.nationalId2 }}</span></td>
                </tr>
              </template>
              <tr>
                <td class="label">{{ $t('ADDRESS') }}:</td>
                <td><span>{{ contract.client.address }} {{ contract.client.district }} {{ contract.client.city }}</span></td>
              </tr>
            </table>
          </b-col>
          <b-col cols="6">
            <span><strong>{{ $t('COMPANY_SIDE') }}:</strong></span><br/>
            <span>{{ $t('COMPANY_NAME') }}</span><br/>
            <span>{{ $t('GPKD_DESCRIPTION') }}</span><br/>
            <span>{{ $t('ADDRESS') }}: {{ branch.address }}</span>
          </b-col>
        </b-row>

        <br/>
        <br/>
        <div><strong>{{ $t('CONFIRM_TWO_SIDE') }}:</strong></div>
        <div class="uppercase"><strong>I. {{ $t('AGREEMENT_ASSET_VALUATION') }}</strong></div>
        <div><strong>{{ $t('ASSET_DESCRIPTION_TSCC') }}:</strong></div>
        <br/>
        <ul>
          <table class="contract">
            <tr>
              <td><li>{{ $t('PLEDGED_ASSET') }}:</li></td>
              <td><span class="margin-left">{{ contract.assetType.description }}</span></td>
            </tr>
            <tr>
              <td><li>{{ $t('ASSET_DESCRIPTION') }}:</li></td>
              <td><div class="margin-left">{{ contract.asset.fullDescriptionVi }}</div></td>
            </tr>
            <tr>
              <td><li>{{ $t('PART_ACCESSORY') }}:</li></td>
              <td><span class="margin-left">{{ contract.asset.meta.accessory }}</span></td>
            </tr>
            <tr v-if="isPurchased">
              <td><li>{{ $t('REALESTATE_CONDITION') }}:</li></td>
              <td><span class="margin-left">{{ $t('REALESTATE_CONDITION_VALUE') }}</span></td>
            </tr>
            <tr v-else>
              <td><li>{{ $t('NUMBERS') }}:</li></td>
              <td><span class="margin-left">01</span></td>
            </tr>
          </table>
        </ul>
        <div><strong>2. {{ $t('PLEGED_CONDITION') }}:</strong></div>
        <ul>
          <table class="contract">
            <tr>
              <td><li>{{ $t('APPROVED_AMOUNT') }}:</li></td>
              <td><span class="margin-left">{{ addCommas(contract.approvedAmount) }} VNĐ</span></td>
            </tr>
            <tr v-if="interestDiscountAmount > 0 && product.prepaid">
              <td>
                <li>{{ $t('DISCOUNT') }}:</li>
              </td>
              <td>
                <strong>{{ addCommas(interestDiscountAmount * MILLION) }} VNĐ</strong>
              </td>
            </tr>
            <tr>
              <td><li>{{ $t('DUE_DATE') }}:</li></td>
              <td><span class="margin-left">{{ moment(contract.dueDate, DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
            </tr>
            <tr>
              <td><li>{{ $t('INTEREST_IN_PERIOD') }}:</li></td>
              <td><span class="margin-left">1.5 %</span></td>
            </tr>
            <tr>
              <td><li>{{ $t('SERVICE_FEE') }}:</li></td>
              <td><span class="margin-left">{{ contract.specialInterestValue - 1.5 }} %</span></td>
            </tr>
          </table>
        </ul>
        <span>
          {{ $t('ICADO_WILL_DISBURSE_FOR_CLIENT') }} <strong>{{ addCommas(receivedAmount) }} VNĐ</strong> {{ interestTypeContent1 }} <strong>{{ addCommas(contract.interestAmount) }} VNĐ</strong>{{ interestTypeContent2 }}
          <strong>{{ $t('I_CONFIRM_THAT') }}:</strong><i>{{ $t('CONFIRM_TERM') }}.</i>
        </span>
        <br/>
        <br/>
        <b-row class="sign">
          <b-col cols="6">
            <center>
              <span>({{ $t('ICADO_REPRESENT') }})</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
          <b-col cols="6">
            <center>
              <span>{{ $t('CLIENT') }}</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
        </b-row>

        <div class="working-hours">{{ $t('WORKING_HOURS') }}</div>
      </page>

      <page class="terms">
        <div class="uppercase"><strong>II. {{ $t('PLEDGED_TERM') }}</strong></div>
        <span>{{ $t('PLEASE_READ_TERM') }}:</span>
        <br/>
        <br/>

        <div><strong>1. {{ $t('PLEGED_CONDITION') }}:</strong></div>
        <ul>
          <li>{{ $t('CONTRACT_WILL_END_IN') }} {{ contract.product.repayEvery }} {{ $t('DAY') }}. {{ $t('ENDING') }} {{ contract.product.repayEvery }} {{ $t('DAY') }}, {{ $t('CLIENT_CAN_REDEEM_OR_RENEW') }}</li>
          <li>{{ $t('TEMP_1') }}.</li>
          <li>{{ $t('TEMP_2') }}.</li>
          <li>{{ $t('TEMP_3') }}:</li>
          <ul style="list-style-type: square;">
            <li>{{ $t('TEMP_3_1') }}.</li>
            <li>{{ $t('TEMP_3_2') }}.</li>
          </ul>
          <li>{{ $t('TEMP_4') }}:</li>
          <br/>
          <center>
            <table class="bank">
              <tr>
                <td colspan="2">{{ $t('VIETCOMBANK_NAME') }}</td>
              </tr>
              <tr>
                <td>{{ $t('ACCOUNT') }}:</td>
                <td>{{ $t('COMPANY_NAME') }}</td>
              </tr>
              <tr>
                <td>{{ $t('ACCOUNT_NUMBER') }}:</td>
                <td>{{ $t('ICADO_BANK_NUMBER') }}</td>
              </tr>
              <tr>
                <td colspan="2">{{ $t('CONTENT_BANK') }}</td>
              </tr>
            </table>
          </center>
          <br/>
          <li>{{ $t('TEMP_5') }}.</li>
        </ul>

        <div><strong>2. {{ $t('INTEREST_AMOUNT_TERM') }}</strong></div>
        <ul>
          <li>{{ $t('INTEREST_AMOUNT_TERM_1') }}.</li>
          <li>{{ $t('INTEREST_AMOUNT_TERM_2') }}.</li>
        </ul>

        <div><strong>3. {{ $t('ASSET_LIQUIDATION') }}</strong></div>
        <ul>
          <li>{{ $t('LIQUIDATION_TERM_1') }}.</li>
          <li>{{ $t('LIQUIDATION_TERM_2') }}.</li>
        </ul>

        <div><strong>4. {{ $t('ASSET_ORIGIN_COMMITMENT') }}</strong></div>
        <ul>
          <li>{{ $t('ASSET_ORIGIN_COMMITMENT_1') }}.</li>
          <li>{{ $t('ASSET_ORIGIN_COMMITMENT_2') }}.</li>
        </ul>

        <div><strong>5. {{ $t('CONTRACT_REDEEM_REGULATION') }}</strong></div>
        <ul>
          <li>{{ $t('CONTRACT_REDEEM_REGULATION_1') }}.</li>
          <li>{{ $t('CONTRACT_REDEEM_REGULATION_2') }}.</li>
          <li>{{ $t('CONTRACT_REDEEM_REGULATION_3') }}.</li>
        </ul>
        <div> <strong>6. {{ $t('ANOTHER_REGULATION') }}</strong></div>
        <ul>
          <li>{{ $t('ANOTHER_REGULATION_1') }}.</li>
          <li>{{ $t('ANOTHER_REGULATION_2') }}.</li>
          <li>{{ $t('ANOTHER_REGULATION_3') }}.</li>
          <li v-if="isPurchased">{{ $t('ANOTHER_REGULATION_4') }}.</li>
        </ul>

        <div class="working-hours">{{ $t('WORKING_HOURS') }}</div>
      </page>

      <page v-if="isAuthorized" class="authorization">
        <div class="nation">{{ $t('NATION') }}</div>
        <div class="motto">{{ $t('MOTTO') }}</div>
        <br/>
        <div class="hr"/>
        <div class="header">
          <div class="logo-holder">
            <logo-inversed-circle class="icon"/>
            <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
          </div>
          <div class="title-info">
            <span class="bill">{{ $t('AUTHORIZATION_CONTRACT') }}</span><br/>
            <span class="bill">{{ $t('BIKE/CAR') }}</span>
          </div>
        </div>
        <br/>
        <br/>
        <br/>
        <span>{{ $t('DATE') }} {{ moment(contract.maturesDate, DATE_FORMAT).format('DD-M-YYYY') }}, {{ $t('BEGIN_PARAM') }}:</span>
        <br/>
        <br/>
        <b-row>
          <b-col cols="6">
            <span><strong>{{ $t('AUTHORIZED_SIDE_1') }}:</strong></span>
            <table>
              <tr>
                <td class="label">{{ $t('FULL_NAME') }}:</td>
                <td><span>{{ contract.client.name }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('PHONE_NUMBER') }}:</td>
                <td><span>{{ contract.client.primaryPhone }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('BORN_DAY') }}:</td>
                <td><span>{{ moment(contract.client.dateOfBirth, DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('NATIONAL_ID') }}:</td>
                <td><span>{{ contract.client.nationalId }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('ADDRESS') }}:</td>
                <td><span>{{ contract.client.address }} {{ contract.client.district }} {{ contract.client.city }}</span></td>
              </tr>
            </table>
          </b-col>
          <b-col cols="6">
            <span><strong>{{ $t('BE_AUTHORIZED_SIDE_1') }}:</strong></span><br/>
            <span>{{ $t('COMPANY_NAME') }}</span><br/>
            <span>{{ $t('GPKD_DESCRIPTION') }}</span><br/>
            <span>{{ $t('ADDRESS') }}: {{ branch.address }}</span>
          </b-col>
        </b-row>
        <br/>
        <br/>
        <div class="uppercase"><strong>I. {{ $t('AGREEMENT_ASSET_VALUATION') }}</strong></div>
        <span>{{ $t('AUTHORIZED_CONTENT_1') }}: {{ branch.name }} - {{ contract.mifosId }} {{ $t('AUTHORIZED_CONTENT_2') }}: {{ branch.name }} - {{ contract.mifosId }}. {{ $t('AUTHORIZED_CONTENT_3') }}:</span>
        <table class="authorized">
          <tr>
            <td><strong>{{ $t('VEHICLE_ID') }}:</strong></td>
            <td><strong class="margin-left">{{ contract.asset.meta.vehicleId }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('CHASSIS_NUMBER') }}:</strong></td>
            <td><strong class="margin-left">{{ contract.asset.meta.chassisNumber }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('LABEL') }}:</strong></td>
            <td><strong class="margin-left">{{ contract.asset.meta.label }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('VEHICLE_TYPE') }}:</strong></td>
            <td><strong class="margin-left">{{ contract.asset.meta.vehicleType }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('PAINTING_COLOR') }}:</strong></td>
            <td><strong class="margin-left">{{ contract.asset.meta.paintingColor }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('LICENSE_PLATE') }}:</strong></td>
            <td><strong class="margin-left">{{ contract.asset.meta.licensePlate }}</strong></td>
          </tr>
        </table>
        <br/>
        <div class="uppercase"><strong>II. {{ $t('COMMITMENT') }}</strong></div>
        <span>{{ $t('COMMITMENT_CONTENT') }}</span>
        <br/>
        <b-row class="sign">
          <b-col cols="6">
            <center>
              <span>{{ $t('AUTHORIZED_SIDE_2') }}</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
          <b-col cols="6">
            <center>
              <span>{{ $t('BE_AUTHORIZED_SIDE_2') }}</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
        </b-row>
      </page>
    </print>

    <div id="note" class="border">
      <center>{{ $t('PRINT_BILL') }}</center>
      <div class="buttons d-flex justify-content-center">
        <primary-button @click="back" class="button primary-button" white rounded-corner :text="$t('BACK')" />
        <icon-button @click="print" class="button" independence :icon="faPrint" :size="40"/>
      </div>
    </div>
  </div>
</template>

<script>
import LogoInversedCircle from '@/components/LogoInversedCircle';
import PrimaryButton from '@/components/PrimaryButton';
import IconButton from '@/components/IconButton';
import Print from '@/components/Print';
import Page from '@/components/Page';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { addCommas } from '@/helpers';
import { computed, onMounted, ref } from '@vue/composition-api';
import { DATE_FORMAT, MILLION } from '@/consts';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { getInterestDiscountAmount } from '@/helpers/contractCalculation';

import contractDetailServices from '@/views/ContractDetail/ContractDetailServices';
import OrderManagementService from '@/views/Order/OrderManagementService';
import promotionServices from '@/services/promotion';

import moment from 'moment';

const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  name: 'ContractReprint',
  components: {
    LogoInversedCircle,
    PrimaryButton,
    IconButton,
    Print,
    Page,
  },
  metaInfo() {
    const { $i18n, $root: { $route } } = this;

    const title = `${$i18n.t('PRINT_CONTRACT')} #${$route.params.id}`;

    return {
      title,
      meta: []
    };
  },
  setup(props, { root, refs }) {
    const { branches } = useAppState(['branches']);
    const branch = ref({});

    const contract = ref({
      client: {},
      product: {},
      assetType: {},
      asset: {
        meta: {},
      },
    });

    const isPurchased = ref(false);
    const isAuthorized = ref(false);
    const interestDiscountAmount = ref(0);
    const receivedAmount = ref(0);

    const interestTypeContent1 = computed(() => {
      if (contract.value.product.prepaid) {
        return root.$t('PREPAID_CONTENT');
      }
      return root.$t('POSTPAID_CONTENT');
    });

    const interestTypeContent2 = computed(() => {
      if (contract.value.product.prepaid) {
        return '.';
      }
      return ` ${root.$t('POSTPAID_CONTENT_END')}.`;
    });

    const back = () => {
      root.$router.back();
    };

    const print = () => {
      refs.print.print();
    };

    onMounted(async () => {
      const { id } = root.$route.params;

      const contractData = await contractDetailServices.getContractDetail(id);

      contract.value = {
        ...contract.value,
        ...contractData,
      };

      isPurchased.value = contractData.assetType.name === 'Realestate';
      isAuthorized.value = ['Car', 'Bike', 'Truck'].includes(contractData.assetType.name);
      branch.value = branches.value.find((item) => item.name === contractData.branch.branchName);

      const orderData = await OrderManagementService.getOrderById(contract.value.order);
      if (contractData.product.prepaid && orderData.promotion && contractData.contractType !== 'renewal') {
        const promotionData = await promotionServices.getPromotionDetail(orderData.promotion);

        interestDiscountAmount.value = getInterestDiscountAmount(
          contract.value.approvedAmount / MILLION,
          contract.value.interestAmount / MILLION,
          promotionData.interestDiscount,
          promotionData.maxDiscount / MILLION,
          promotionData.minDiscount / MILLION,
          promotionData.minPayout / MILLION,
        );
      }

      receivedAmount.value = Math.round(contract.value.approvedAmount - contract.value.interestAmount + interestDiscountAmount.value * MILLION);
    });

    return {
      contract,
      branch,
      interestDiscountAmount,
      receivedAmount,
      isPurchased,
      isAuthorized,
      interestTypeContent1,
      interestTypeContent2,
      faPrint,
      addCommas,
      back,
      print,
      moment,
      DATE_FORMAT,
      MILLION,
    };
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#contract-print {
  padding: 32px 30px;

  .terms {
    font-size: 12.5px;
    padding: 7mm 10mm 7mm 10mm;
  }

  .authorization {
    font-size: 14px;
    padding: 5mm 10mm 5mm 10mm;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .hr {
    border: 1px solid $iron;
    width: 320px;
    margin: 0px auto;
  }

  .nation {
    size: 13px;
    text-align: center;
  }

  .motto {
    size: 11px;
    line-height: 18px;
    text-align: center;
  }

  .header {
    margin-top: 30px;
    position: relative;

    .logo-holder {
      position: absolute;
      top: 5px;
      left: 0;

      .left {
        padding-left: 26px;
        padding-top: 7px;
      }

      .icon {
        color: $alizarinCrimson;
        height: 80px;
        width: 80px;
      }

      .camdo {
        font-size: 15px;
        color: $carmine;
        font-family: 'Source Sans Pro', Tahoma, Arial;
      }

      .nhanh {
        font-size: 15px;
        color: $alizarinCrimson;
      }
    }

    .title-info {
      text-align: center;
      width: 100%;
    }

    .bill {
      text-transform: uppercase;
      font-weight: bolder;
      font-size: 24px;
    }

    .info {
      font-size: 13px;
    }
  }

  ul {
    list-style-type: circle;
  }

  table {
    width: 100%;
    border-spacing: 0;

    &.authorized {
      margin-top: 35px;
      tr {
        td {
          &:first-child {
            width: 115px;
          }
        }
      }
    }

    &.contract {
      tr {
        td {
          &:first-child {
            width: 120px;
          }
        }
      }
    }

    &.bank {
      border: 1px solid $black;
      border-collapse: collapse;
      width: 478px;

      tr {
        td {
          border: 1px solid $black;
          border-collapse: collapse;
          padding: 3px;
        }
      }
    }

    .margin-left {
      margin-left: 50px;
    }

    td {
      &.label {
        width: 120px;
        vertical-align: top;
      }
    }
  }

  .sign {
    margin-top: 20px;
  }

  .divider {
    height: 0;
    border-bottom: 1px dashed $alto;
    width: calc(100% + 20mm);
    margin-left: -10mm;
    margin-top: 80px;
    margin-bottom: 20px;
  }

  #note {
    background-color: $white;
    font-size: 20px;
    padding: 30px;
    position: fixed;
    top: 200px;
    right: 15px;
    width: 350px;
    border-radius: 4px;

    @media (max-width: 1600px) {
      opacity: 0.5;
      transition: all .2s ease-in-out;

      &:hover {
        opacity: 1;
      }
    }

    center {
      font-weight: bolder;
      text-transform: uppercase;
    }

    .buttons {
      margin-top: 28px;

      .button {
        margin: 0px 4px;
        box-shadow: 0px 3px 6px $silver;
      }

      .primary-button {
        padding: 0px 20px;

        /deep/ span {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
